import { useIncidentDetail } from '../portal';
import type { LiveVideo } from '../realtime';

export type UseIncidentLiveVideosResult = {
  liveVideos: readonly LiveVideo[];
  isLoading: boolean;
  unavailable: boolean;
  retry: () => void;
};

export function useIncidentLiveVideos(incidentId: string): UseIncidentLiveVideosResult {
  const { incident, status, retry } = useIncidentDetail(incidentId);

  return {
    liveVideos: incident?.caller.liveVideos ?? [],
    isLoading: status === 'loading',
    unavailable: status === 'not-found' || status === 'failed',
    retry,
  };
}

export function findRecording(liveVideos: readonly LiveVideo[], videoId: string): LiveVideo | null {
  return liveVideos.find((liveVideo) => liveVideo.id.toLowerCase() === videoId.toLowerCase()) ?? null;
}
